export default "__VITE_ASSET__DQRSk891__"